import type { UniversityProgram } from './universityData'

// SJVC programs (program IDs from advertiser spec)
export const SJVC_PROGRAMS: Record<number, UniversityProgram> = {
  238: {
    name: 'Electrical Technology',
    category: 'Skilled Trades',
    degreeLevel: 'Diploma',
    slug: 'electrical-technology',
  },
  239: {
    name: 'Heating, Ventilation, AC and Refrigeration',
    category: 'Skilled Trades',
    degreeLevel: 'Diploma',
    slug: 'hvac',
  },
  240: {
    name: 'Maintenance Technician',
    category: 'Skilled Trades',
    degreeLevel: 'Diploma',
    slug: 'maintenance-technician',
  },
  243: {
    name: 'Construction Management',
    category: 'Skilled Trades',
    degreeLevel: 'Diploma',
    slug: 'construction-management',
  },
}

export interface SJVCCampus {
  id: number
  name: string
  programIds: number[]
}

// Campus list with the program IDs available at each campus
export const SJVC_CAMPUSES: SJVCCampus[] = [
  { id: 33, name: 'Bakersfield', programIds: [238, 239] },
  { id: 36, name: 'Fresno TEC', programIds: [238, 239] },
  { id: 38, name: 'Hesperia', programIds: [238, 239] },
  { id: 39, name: 'Lancaster', programIds: [239] },
  { id: 41, name: 'Modesto', programIds: [238, 240] },
  { id: 43, name: 'Ontario', programIds: [238, 239, 240, 243] },
  { id: 45, name: 'Rancho Mirage', programIds: [238, 239] },
  { id: 46, name: 'Santa Maria', programIds: [] },
  { id: 47, name: 'Temecula', programIds: [238, 239] },
  { id: 48, name: 'Visalia', programIds: [238, 239, 240] },
  { id: 220, name: 'San Leandro', programIds: [238] },
  { id: 222, name: 'Phoenix TEC', programIds: [238, 239] },
  { id: 223, name: 'Sacramento', programIds: [238] },
]

// Zip → Campus ID mapping. Built from the advertiser-provided list.
export const SJVC_ZIP_TO_CAMPUS: Record<string, number> = {
  // Temecula (47)
  '92003': 47,
  '92026': 47,
  '92028': 47,
  '92059': 47,
  '92061': 47,
  '92082': 47,
  '92083': 47,
  '92084': 47,
  '92088': 47,
  '92518': 47,
  '92530': 47,
  '92531': 47,
  '92532': 47,
  '92536': 47,
  '92543': 47,
  '92544': 47,
  '92545': 47,
  '92546': 47,
  '92548': 47,
  '92551': 47,
  '92552': 47,
  '92555': 47,
  '92562': 47,
  '92563': 47,
  '92564': 47,
  '92567': 47,
  '92570': 47,
  '92571': 47,
  '92572': 47,
  '92581': 47,
  '92582': 47,
  '92583': 47,
  '92584': 47,
  '92585': 47,
  '92586': 47,
  '92587': 47,
  '92589': 47,
  '92590': 47,
  '92591': 47,
  '92592': 47,
  '92593': 47,
  '92595': 47,
  '92596': 47,
  '92599': 47,
  // Bakersfield (33)
  '93203': 33,
  '93206': 33,
  '93220': 33,
  '93241': 33,
  '93250': 33,
  '93252': 33,
  '93263': 33,
  '93268': 33,
  '93276': 33,
  '93280': 33,
  '93301': 33,
  '93302': 33,
  '93303': 33,
  '93304': 33,
  '93305': 33,
  '93306': 33,
  '93307': 33,
  '93308': 33,
  '93309': 33,
  '93311': 33,
  '93312': 33,
  '93313': 33,
  '93314': 33,
  '93380': 33,
  '93383': 33,
  '93384': 33,
  '93385': 33,
  '93386': 33,
  '93387': 33,
  '93388': 33,
  '93389': 33,
  '93390': 33,
  '93531': 33,
  // Hesperia (38)
  '91759': 38,
  '92301': 38,
  '92307': 38,
  '92308': 38,
  '92317': 38,
  '92321': 38,
  '92322': 38,
  '92325': 38,
  '92329': 38,
  '92340': 38,
  '92342': 38,
  '92344': 38,
  '92345': 38,
  '92352': 38,
  '92358': 38,
  '92368': 38,
  '92371': 38,
  '92372': 38,
  '92378': 38,
  '92391': 38,
  '92392': 38,
  '92393': 38,
  '92394': 38,
  '92395': 38,
  '92397': 38,
  '92407': 38,
  // Lancaster (39) — 93544 appears in both Hesperia and Lancaster lists; resolved to Lancaster as the more specific zip pool.
  '91390': 39,
  '93243': 39,
  '93501': 39,
  '93510': 39,
  '93524': 39,
  '93534': 39,
  '93535': 39,
  '93536': 39,
  '93539': 39,
  '93543': 39,
  '93544': 39,
  '93550': 39,
  '93551': 39,
  '93552': 39,
  '93560': 39,
  '93563': 39,
  '93584': 39,
  '93586': 39,
  '93590': 39,
  '93591': 39,
  '93599': 39,
  // Santa Maria (46)
  '93420': 46,
  '93421': 46,
  '93427': 46,
  '93429': 46,
  '93433': 46,
  '93434': 46,
  '93436': 46,
  '93437': 46,
  '93438': 46,
  '93440': 46,
  '93441': 46,
  '93444': 46,
  '93445': 46,
  '93448': 46,
  '93449': 46,
  '93454': 46,
  '93455': 46,
  '93456': 46,
  '93457': 46,
  '93458': 46,
  '93460': 46,
  '93463': 46,
  '93464': 46,
  '93475': 46,
  '93483': 46,
  // Ontario (43)
  '91701': 43,
  '91708': 43,
  '91710': 43,
  '91711': 43,
  '91729': 43,
  '91730': 43,
  '91737': 43,
  '91739': 43,
  '91743': 43,
  '91750': 43,
  '91752': 43,
  '91758': 43,
  '91761': 43,
  '91762': 43,
  '91763': 43,
  '91764': 43,
  '91766': 43,
  '91767': 43,
  '91768': 43,
  '91769': 43,
  '91784': 43,
  '91785': 43,
  '91786': 43,
  '92316': 43,
  '92331': 43,
  '92334': 43,
  '92335': 43,
  '92337': 43,
  '92376': 43,
  '92377': 43,
  '92501': 43,
  '92502': 43,
  '92503': 43,
  '92505': 43,
  '92509': 43,
  '92513': 43,
  '92514': 43,
  '92515': 43,
  '92516': 43,
  '92517': 43,
  '92519': 43,
  '92522': 43,
  '92823': 43,
  '92860': 43,
  '92877': 43,
  '92878': 43,
  '92879': 43,
  '92880': 43,
  // Rancho Mirage (45)
  '92201': 45,
  '92202': 45,
  '92203': 45,
  '92210': 45,
  '92211': 45,
  '92230': 45,
  '92234': 45,
  '92235': 45,
  '92236': 45,
  '92240': 45,
  '92241': 45,
  '92247': 45,
  '92248': 45,
  '92252': 45,
  '92253': 45,
  '92255': 45,
  '92256': 45,
  '92258': 45,
  '92260': 45,
  '92261': 45,
  '92262': 45,
  '92263': 45,
  '92264': 45,
  '92270': 45,
  '92276': 45,
  '92282': 45,
  '92284': 45,
  '92286': 45,
  '92539': 45,
  '92549': 45,
  '92561': 45,
  // Visalia (48)
  '93202': 48,
  '93204': 48,
  '93210': 48,
  '93212': 48,
  '93221': 48,
  '93223': 48,
  '93227': 48,
  '93230': 48,
  '93232': 48,
  '93234': 48,
  '93235': 48,
  '93239': 48,
  '93242': 48,
  '93244': 48,
  '93245': 48,
  '93246': 48,
  '93247': 48,
  '93256': 48,
  '93257': 48,
  '93258': 48,
  '93266': 48,
  '93267': 48,
  '93272': 48,
  '93274': 48,
  '93275': 48,
  '93277': 48,
  '93278': 48,
  '93279': 48,
  '93282': 48,
  '93286': 48,
  '93291': 48,
  '93292': 48,
  '93615': 48,
  '93618': 48,
  '93631': 48,
  '93647': 48,
  '93656': 48,
  '93662': 48,
  '93666': 48,
  '93670': 48,
  '93673': 48,
  // Modesto (41)
  '95208': 41,
  '95307': 41,
  '95313': 41,
  '95316': 41,
  '95319': 41,
  '95320': 41,
  '95324': 41,
  '95326': 41,
  '95328': 41,
  '95336': 41,
  '95337': 41,
  '95350': 41,
  '95351': 41,
  '95352': 41,
  '95353': 41,
  '95354': 41,
  '95355': 41,
  '95356': 41,
  '95357': 41,
  '95358': 41,
  '95361': 41,
  '95363': 41,
  '95366': 41,
  '95367': 41,
  '95368': 41,
  '95380': 41,
  '95381': 41,
  '95382': 41,
  '95385': 41,
  '95386': 41,
  '95387': 41,
  '95397': 41,
  // Fresno TEC (36)
  '93601': 36,
  '93602': 36,
  '93606': 36,
  '93607': 36,
  '93609': 36,
  '93610': 36,
  '93611': 36,
  '93612': 36,
  '93613': 36,
  '93614': 36,
  '93616': 36,
  '93619': 36,
  '93622': 36,
  '93625': 36,
  '93626': 36,
  '93630': 36,
  '93636': 36,
  '93637': 36,
  '93638': 36,
  '93639': 36,
  '93645': 36,
  '93646': 36,
  '93648': 36,
  '93649': 36,
  '93650': 36,
  '93651': 36,
  '93652': 36,
  '93653': 36,
  '93654': 36,
  '93657': 36,
  '93660': 36,
  '93667': 36,
  '93675': 36,
  '93701': 36,
  '93702': 36,
  '93703': 36,
  '93704': 36,
  '93705': 36,
  '93706': 36,
  '93707': 36,
  '93708': 36,
  '93709': 36,
  '93710': 36,
  '93711': 36,
  '93712': 36,
  '93714': 36,
  '93715': 36,
  '93716': 36,
  '93717': 36,
  '93718': 36,
  '93720': 36,
  '93721': 36,
  '93722': 36,
  '93723': 36,
  '93724': 36,
  '93725': 36,
  '93726': 36,
  '93727': 36,
  '93728': 36,
  '93729': 36,
  '93730': 36,
  '93737': 36,
  '93740': 36,
  '93741': 36,
  '93744': 36,
  '93745': 36,
  '93747': 36,
  '93750': 36,
  '93755': 36,
  '93760': 36,
  '93761': 36,
  '93764': 36,
  '93765': 36,
  '93771': 36,
  '93772': 36,
  '93773': 36,
  '93774': 36,
  '93775': 36,
  '93776': 36,
  '93777': 36,
  '93778': 36,
  '93779': 36,
  '93786': 36,
  '93790': 36,
  '93791': 36,
  '93792': 36,
  '93793': 36,
  '93794': 36,
  '93844': 36,
  '93888': 36,
  '95301': 36,
  '95306': 36,
  '95317': 36,
  '95333': 36,
  '95338': 36,
  '95340': 36,
  '95341': 36,
  '95343': 36,
  '95344': 36,
  '95348': 36,
  // San Leandro (220)
  '94502': 220,
  '94536': 220,
  '94538': 220,
  '94539': 220,
  '94540': 220,
  '94541': 220,
  '94542': 220,
  '94543': 220,
  '94544': 220,
  '94545': 220,
  '94546': 220,
  '94550': 220,
  '94551': 220,
  '94552': 220,
  '94555': 220,
  '94556': 220,
  '94557': 220,
  '94560': 220,
  '94566': 220,
  '94568': 220,
  '94577': 220,
  '94578': 220,
  '94579': 220,
  '94580': 220,
  '94582': 220,
  '94583': 220,
  '94586': 220,
  '94587': 220,
  '94588': 220,
  '94601': 220,
  '94603': 220,
  '94605': 220,
  '94606': 220,
  '94613': 220,
  '94614': 220,
  '94619': 220,
  '94620': 220,
  '94621': 220,
  '94624': 220,
  // Phoenix TEC (222)
  '85001': 222,
  '85002': 222,
  '85003': 222,
  '85004': 222,
  '85005': 222,
  '85006': 222,
  '85007': 222,
  '85008': 222,
  '85009': 222,
  '85010': 222,
  '85011': 222,
  '85012': 222,
  '85013': 222,
  '85014': 222,
  '85015': 222,
  '85016': 222,
  '85017': 222,
  '85018': 222,
  '85019': 222,
  '85020': 222,
  '85021': 222,
  '85022': 222,
  '85023': 222,
  '85024': 222,
  '85026': 222,
  '85027': 222,
  '85028': 222,
  '85029': 222,
  '85030': 222,
  '85031': 222,
  '85032': 222,
  '85033': 222,
  '85034': 222,
  '85035': 222,
  '85036': 222,
  '85037': 222,
  '85038': 222,
  '85040': 222,
  '85041': 222,
  '85042': 222,
  '85043': 222,
  '85046': 222,
  '85050': 222,
  '85051': 222,
  '85053': 222,
  '85054': 222,
  '85055': 222,
  '85060': 222,
  '85061': 222,
  '85062': 222,
  '85063': 222,
  '85064': 222,
  '85065': 222,
  '85066': 222,
  '85067': 222,
  '85068': 222,
  '85069': 222,
  '85070': 222,
  '85071': 222,
  '85072': 222,
  '85074': 222,
  '85075': 222,
  '85076': 222,
  '85078': 222,
  '85079': 222,
  '85080': 222,
  '85082': 222,
  '85083': 222,
  '85085': 222,
  '85086': 222,
  '85087': 222,
  '85098': 222,
  '85099': 222,
  '85254': 222,
  '85301': 222,
  '85302': 222,
  '85303': 222,
  '85304': 222,
  '85305': 222,
  '85306': 222,
  '85307': 222,
  '85308': 222,
  '85323': 222,
  '85326': 222,
  '85335': 222,
  '85338': 222,
  '85339': 222,
  '85345': 222,
  '85351': 222,
  '85353': 222,
  '85374': 222,
  '85379': 222,
  '85382': 222,
  '85388': 222,
  '85392': 222,
  // Sacramento (223)
  '94203': 223,
  '94205': 223,
  '94206': 223,
  '94207': 223,
  '94208': 223,
  '94209': 223,
  '94211': 223,
  '94229': 223,
  '94230': 223,
  '94232': 223,
  '94234': 223,
  '94235': 223,
  '94236': 223,
  '94237': 223,
  '94239': 223,
  '94240': 223,
  '94244': 223,
  '94246': 223,
  '94247': 223,
  '94248': 223,
  '94249': 223,
  '94250': 223,
  '94252': 223,
  '94254': 223,
  '94256': 223,
  '94257': 223,
  '94258': 223,
  '94259': 223,
  '94261': 223,
  '94262': 223,
  '94263': 223,
  '94267': 223,
  '94268': 223,
  '94269': 223,
  '94271': 223,
  '94273': 223,
  '94274': 223,
  '94277': 223,
  '94278': 223,
  '94279': 223,
  '94280': 223,
  '94282': 223,
  '94283': 223,
  '94284': 223,
  '94285': 223,
  '94286': 223,
  '94287': 223,
  '94288': 223,
  '94289': 223,
  '94290': 223,
  '94291': 223,
  '94293': 223,
  '94294': 223,
  '94295': 223,
  '94296': 223,
  '94297': 223,
  '95605': 223,
  '95608': 223,
  '95612': 223,
  '95615': 223,
  '95616': 223,
  '95617': 223,
  '95618': 223,
  '95620': 223,
  '95624': 223,
  '95626': 223,
  '95632': 223,
  '95638': 223,
  '95648': 223,
  '95655': 223,
  '95669': 223,
  '95670': 223,
  '95673': 223,
  '95683': 223,
  '95690': 223,
  '95691': 223,
  '95693': 223,
  '95695': 223,
  '95742': 223,
  '95747': 223,
  '95757': 223,
  '95758': 223,
  '95776': 223,
  '95798': 223,
  '95799': 223,
  '95812': 223,
  '95815': 223,
  '95820': 223,
  '95821': 223,
  '95822': 223,
  '95823': 223,
  '95824': 223,
  '95825': 223,
  '95826': 223,
  '95827': 223,
  '95828': 223,
  '95829': 223,
  '95831': 223,
  '95832': 223,
  '95833': 223,
  '95834': 223,
  '95835': 223,
  '95838': 223,
  '95843': 223,
  '95864': 223,
}

export const getSJVCCampusByZip = (zip: string): SJVCCampus | null => {
  const campusId = SJVC_ZIP_TO_CAMPUS[zip]
  if (!campusId) return null
  return SJVC_CAMPUSES.find((c) => c.id === campusId) || null
}

export const getSJVCProgramsForCampus = (
  campusId: number,
): UniversityProgram[] => {
  const campus = SJVC_CAMPUSES.find((c) => c.id === campusId)
  if (!campus) return []
  return campus.programIds
    .map((id) => SJVC_PROGRAMS[id])
    .filter(Boolean)
    .map((p) => ({ ...p }))
}
